import { useSyncExternalStore } from "react";

const STORAGE_KEY = "DMIfavourites";

/* ---------- Internal store ---------- */

function normalize(item) {
  const id = String(item.id ?? item.gid);
  return { ...item, id };
}
let favourites = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]").map(
  normalize
);

const listeners = new Set();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

function save(newFavs) {
  favourites = newFavs;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(newFavs));
  // Notify legacy js in sitepackage
  window.dispatchEvent(new Event("DMIFavouritesChanged"));
  emit();
}

/* Cross-tab sync */
window.addEventListener("storage", (e) => {
  if (e.key === STORAGE_KEY) {
    favourites = JSON.parse(e.newValue || "[]").map(normalize);
    emit();
  }
});

/* Same-tab legacy JS sync */
window.addEventListener("DMIFavouritesChanged", () => {
  favourites = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  emit();
});

/* ---------- Store API ---------- */

export const favouritesStore = {
  get() {
    return favourites;
  },

  subscribe(cb) {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },

  add(item) {
    const normalized = normalize(item);
    const filtered = favourites.filter((f) => String(f.id) !== normalized.id);
    save([...filtered, normalized]);
  },

  remove(id) {
    const normId = String(id);
    save(favourites.filter((f) => String(f.id) !== normId));
  },
};

/* ---------- React hook ---------- */

export function useFavouritesStore() {
  return useSyncExternalStore(
    favouritesStore.subscribe,
    favouritesStore.get,
    favouritesStore.get
  );
}
